<section
  class="rs-content-wrapper rs-header-has-level2"
  id="internetLevelTwo"
  *ngIf="!hasError || selectedProduct || isPending"
>
  <mprd-skeleton-internet-level-two *ngIf="!selectedProduct"></mprd-skeleton-internet-level-two>
  <main id="maincontent" role="main" *ngIf="selectedProduct">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit">
            {{ selectedProduct?.productDescription }}
          </h1>
          <p
            class="rs-txt-s5 rs-txt-c2"
            x-ms-format-detection="none"
            data-cy="internetLevelTwoAccessNumber"
          >
            {{ productSubDescription }}
          </p>

          <!--START MESSAGE BOX-->
          <mprd-message-box
            *ngIf="copperOutPhasingOffer"
            [messageBox]="{
              type: 'warning',
              title: copperOutPhasingOffer?.content?.offerTitle,
              description: copperOutPhasingOffer?.content?.shortDescription,
              btnLabel: copperOutPhasingOffer?.content?.moreInfoLabel?.value,
              btnUrl: copperOutPhasingOffer?.content?.offerDetailPage
            }"
            taggingName="myproducts.internet.options"
            data-cy="copperStopSellingInternet"
          ></mprd-message-box>

          <div class="panel rs-panel-big clearfix">
            <mprd-usage-header
              [product]="selectedProduct"
              [remainingDaysLabel]="remainingDaysLabel"
              *ngIf="remainingDaysLabel"
            ></mprd-usage-header>
            <div class="row" data-masonry-container="">
              <div class="columns small-12 medium-6" data-masonry-item-sizer=""></div>
              <div class="columns small-12 medium-6" data-masonry-item="">
                <ng-container *ngIf="!isDeepLink">
                <px-usage-level-2-container
                  [product]="usageProduct"
                  (usageRemainingDays)="usageInitializedWith($event)"
                ></px-usage-level-2-container>
                </ng-container>
                <ng-container *ngIf="isDeepLink">
                  <ng-container *ngIf="usageProduct; else usageSkeleton">
                    <px-usage-level-2-container [product]="usageProduct"
                      (usageRemainingDays)="usageInitializedWith($event)"></px-usage-level-2-container>
                  </ng-container>
                  <ng-template #usageSkeleton>
                    <px-usage-level-2-container></px-usage-level-2-container>
                  </ng-template>
                </ng-container>
              </div>

              <mprd-available-speed [product]="selectedProduct"></mprd-available-speed>

              <mprd-wifi-credentials
                *ngIf="showHgw4"
                [product]="selectedProduct"
                data-cy="wifiCredentialsSection"
              ></mprd-wifi-credentials>

              <mprd-my-internet-apps [internetProduct]="selectedProduct"></mprd-my-internet-apps>

              <mprd-public-wifi [internetProduct]="selectedProduct"></mprd-public-wifi>
              <div class="columns small-12 medium-6" data-masonry-item="">
                <px-bipt
                  *ngIf="selectedProduct && isRes"
                  [plc]="selectedProduct.plc"
                  [serviceId]="selectedProduct.accessNumber"
                  [analyticsLocation]="'internet options'"
                  (displayBipt)="initBipt()"
                ></px-bipt>
              </div>
            </div>

            <div class="rs-me"></div>

            <mprd-internet-available-options-container
              id="available-options"
              data-cy="internetAvailableOptions"
            ></mprd-internet-available-options-container>
            <mprd-internet-settings></mprd-internet-settings>
          </div>

          <div class="rs-mh-s2 rs-mh-m6"></div>

          <div class="rs-le2"></div>
        </div>
      </div>
      <!-- START - FAQ -->
      <div [innerHtml]="faqHtml"></div>
      <!-- END - FAQ -->
    </section>
  </main>
</section>
